<template>
    <div v-if="hasAccess">
        <top-nav-bar></top-nav-bar>

        <div v-if="!loading" class="h-full">
            <div v-if="documents.length">
                <div class="mb-2">
                    <list>
                        <list-item class="text-base sm:text-xl" url="#" v-for="document in documents" :key="document.id"
                                   @click.native.prevent @click="navigateTo(document)">
                            <template slot="icon">
                                <i class="fa text-blue text-xl" :class="getIcon(document.type)"></i>
                            </template>
                            <template slot="title">{{document.type}}</template>
                            <template slot="sub-title" v-if="document.expire_date">
                                Expires {{document.expire_date}}
                            </template>
                            <template slot="status">
                                <i class="fal text-lg mr-2" :class="findDocumentStatusIconStyles(document)"></i>

                                <span class="font-heading uppercase text-xs font-bold"
                                      :class="findDocumentStatusStyles(document)">
                                    {{document.status_name}}
                                </span>
                            </template>
                        </list-item>
                    </list>
                </div>
            </div>
            <div class="text-center p-4 text-grey-dark" v-else>
                You currently have no documents.
            </div>
        </div>
        <div v-else class="h-full flex items-center justify-center pt-4">
            <div class="spinner-blue"></div>
        </div>
    </div>
</template>

<script>
    import ShowsDocumentStatus from '../mixins/ShowsDocumentStatus';
    import CanAccessView from "../mixins/CanAccessView";

    export default {

        data() {
            return {
                loading: true,
                documents: [],
            }
        },

        mixins: [ShowsDocumentStatus, CanAccessView],

        mounted() {
            this.$api('hr').get('employee/documents')
                .then(({data}) => {
                    this.documents = data.data;
                    this.loading = false;
                })
                .catch(({response}) => {
                    this.loading = false;
                });

        },

        computed: {
            number_of_missing() {
                return this.documents.filter((document) => (document.status === 'missing')).length;
            },

            number_of_expired() {
                return this.documents.filter((document) => (document.status === 'expired')).length;
            },
        },

        methods: {
            navigateTo(request) {
                if (request.id !== null) {
                    this.$router.push('/documents/' + request.id)
                } else {
                    this.$router.push('/documents/mandatory/' + request.type)
                }
            },

            getIcon(type) {
                if (type === 'Passport') {
                    return 'fa-passport';
                } else if (type === 'Contract of Employment') {
                    return 'fa-file-signature';
                } else {
                    return 'fa-file';
                }
            }
        },

    }
</script>
